// AboutSigmaStudio.jsx
import React, { useState } from 'react';
import MainLayout from '../../layouts/MainLayout';
import '../../styles/Think5WhysHelp.css';
const AboutThink5WhysRCA = () => {
  const topics = [
    {
      title: "Think5Whys: Revolutionizing Root Cause Analysis",
      description: (
        <div>
          <p>In today's dynamic and fast-paced world, effectively identifying the root causes behind issues, challenges, and incidents is paramount for sustainable growth and success.</p>
          <br />

          <p>Enter <strong>Think5Whys</strong>, an innovative platform designed to streamline and enhance the root cause analysis (RCA) process.</p>
          <br />

          <p>Evolved from the renowned "5 Whys" technique, Think5Whys transcends traditional problem-solving methods by offering a robust and seamless experience for addressing a myriad of issues. Whether it's a technical glitch, operational inefficiency, or strategic setback, Think5Whys provides a comprehensive framework for dissecting complex problems and uncovering their underlying causes.</p>
          <br />

          <p>At the heart of Think5Whys lies its user-friendly interface, empowering individuals and teams to effortlessly navigate through the RCA journey. Users can begin by crafting a precise problem statement, setting the stage for a systematic exploration of the issue at hand. From there, Think5Whys guides users through the iterative process of asking "why" up to five times, delving deeper with each inquiry to unearth the root cause.</p>
          <br />

          <p>But Think5Whys doesn't stop there. Unlike conventional RCA approaches that often result in scattered documentation and disjointed analysis, Think5Whys offers a centralized system for organizing and maintaining RCA findings. By seamlessly integrating problem statements, why1 to why5 analyses, and resultant insights, Think5Whys empowers users to build a comprehensive repository of actionable intelligence.
          </p><br />

          <p>Furthermore, Think5Whys isn't limited to troubleshooting problems alone. Recognizing the importance of goal-setting and objective alignment in driving organizational success, Think5Whys extends its capabilities to facilitate goal-oriented RCA. Whether it's identifying barriers to goal achievement or optimizing strategies for success, Think5Whys provides a versatile platform for achieving desired outcomes.</p>
          <br />

          <p>In essence, Think5Whys represents a paradigm shift in the realm of root cause analysis, offering a holistic approach to problem-solving and goal attainment. With its intuitive interface, systematic methodology, and integrated documentation capabilities, Think5Whys stands as a beacon of efficiency and effectiveness in today's ever-evolving landscape of challenges and opportunities.</p>
          <br />

        </div>
      ),
    },
    {
      title: "Think5Whys Example Database",
      description: (
        <div>
          <p>
          Think5Whys Example Database.
          </p>
        </div>
      ),
    },
    {
      title: "Problem Statement",
      description: (
        <div>
          <p>
          Problem Statement
          </p>
        </div>
      ),
    },
    {
      title: "Why 1",
      description: (
        <div>
          <p>
            Why 1
          </p>
        </div>
      ),
    },
    {
      title: "Why 2",
      description: (
        <div>
          <p>
            Why 2
          </p>
        </div>
      ),
    },
    {
      title: "Why 3",
      description: (
        <div>
          <p>
            Why 3
          </p>
        </div>
      ),
    },
    {
      title: "Why 4",
      description: (
        <div>
          <p>
            Why 4
          </p>
        </div>
      ),
    },
    {
      title: "Why 5",
      description: (
        <div>
          <p>
            Why 5
          </p>
        </div>
      ),
    },
    {
      title: "Root Cause Statement",
      description: (
        <div>
          <p>
          Root Cause Statement
          </p>
        </div>
      ),
    },
    {
      title: "Solution Identification",
      description: (
        <div>
          <p>
              Solution Identification
          </p>
        </div>
      ),
    },
    {
      title: "Solution Actions",
      description: (
        <div>
          <p>
            Solution Actions
          </p>
        </div>
      ),
    },
    {
      title: "Imapct Analysis",
      description: (
        <div>
          <p>
             Before & After Impact Analysis
          </p>
        </div>
      ),
    },
  ];

  const [expandedTopic, setExpandedTopic] = useState(null);

  const handleTopicClick = (index) => {
    setExpandedTopic(expandedTopic === index ? null : index);
  };

  return (
    <MainLayout>
      <div className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>
        <h2>About Think5Whys Root Cause Analysis</h2>
      </div>
      <div className="help-container">
        <ul className="help-list">
          {topics.map((topic, index) => (
            <li key={index} onClick={() => handleTopicClick(index)} className="help-topic">
              {topic.title}
              {expandedTopic === index && (
                <div className="help-description">
                  <p>{topic.description}</p>
                </div>
              )}
            </li>
          ))}
        </ul>
      </div>
    </MainLayout>
  );
};

export default AboutThink5WhysRCA;


